let data={login:"",utype:"",name:"",token:"",facilityid:0,facilityname:""};
export function appReducer(state=data,action)
{
    if(action.type=="setLogin")
    {
        return {...state,login:action.value};
    }
    else if(action.type=="setUType")
    {
        return {...state,utype:action.value};
    }
    else if(action.type=="setName")
    {
        return {...state,name:action.value};
    }
    else if(action.type=="setToken")
    {
        return {...state,token:action.value};
    }
    else if(action.type=="setFacilityId")
    {
        return {...state,facilityid:action.value};
    }
    else if(action.type=="setFacilityName")
    {
        return {...state,facilityname:action.value};
    }
    else 
        return state;
}
/*
setLogin
setUType
setName
setToken
*/